//Example for use this Modal:

/*
const [showConfirmModalDelete, setShowConfirmModalDelete] = useState(false);

const contentBodyDelete = (
    <div>Are you sure you want to delete this item?</div>

);
const contentFooterDelete = (
    <>
        <Button className="button-bg-grow border-0" onClick={() => {
            setShowConfirmModalDelete(false); // Close Modal
        }}>Exit Without Saving</Button>
        {' '}
        <Button className="button-bg-denial border-0" onClick={() => setShowConfirmModalDelete(false)}>Cancel</Button>
    </>
);

return (
    <>
        <CustomModal isOpen={showConfirmModalDelete} toggle={() => setShowConfirmModalDelete(!showConfirmModalDelete)} body={contentBodyDelete} footer={contentFooterDelete}/>
        <Button onClick={()=>{setShowConfirmModalDelete(true)}}>Test Modal</Button>
    </>
    )
*/

//setShowConfirmModalDelete(true) for show modal


import React, { useEffect } from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

let openModalsCount = 0;
let previousBodyOverflow = '';
let previousBodyPaddingRight = '';
let previousBodyPosition = '';
let previousBodyTop = '';
let previousBodyWidth = '';
let previousHtmlOverflow = '';
let previousHtmlPaddingRight = '';
let lastScrollY = 0;

function isInsideModalContent(target) {
    return target instanceof Element && !!target.closest('.custom-modal-outline .modal-content');
}

function preventBackgroundScroll(event) {
    if (isInsideModalContent(event.target)) {
        return;
    }

    event.preventDefault();
}

function lockBodyScroll() {
    const body = document.body;
    const html = document.documentElement;

    if (openModalsCount === 0) {
        previousBodyOverflow = body.style.overflow;
        previousBodyPaddingRight = body.style.paddingRight;
        previousBodyPosition = body.style.position;
        previousBodyTop = body.style.top;
        previousBodyWidth = body.style.width;
        previousHtmlOverflow = html.style.overflow;
        previousHtmlPaddingRight = html.style.paddingRight;

        lastScrollY = window.scrollY || window.pageYOffset || 0;

        const scrollbarWidth = window.innerWidth - html.clientWidth;

        html.style.overflow = 'hidden';
        body.style.overflow = 'hidden';
        body.style.position = 'fixed';
        body.style.top = `-${lastScrollY}px`;
        body.style.width = '100%';

        if (scrollbarWidth > 0) {
            body.style.paddingRight = `${scrollbarWidth}px`;
            html.style.paddingRight = `${scrollbarWidth}px`;
        }

        document.addEventListener('wheel', preventBackgroundScroll, { passive: false });
        document.addEventListener('touchmove', preventBackgroundScroll, { passive: false });
    }

    openModalsCount += 1;
}

function unlockBodyScroll() {
    const body = document.body;
    const html = document.documentElement;

    openModalsCount = Math.max(openModalsCount - 1, 0);

    if (openModalsCount === 0) {
        document.removeEventListener('wheel', preventBackgroundScroll);
        document.removeEventListener('touchmove', preventBackgroundScroll);

        html.style.overflow = previousHtmlOverflow;
        html.style.paddingRight = previousHtmlPaddingRight;
        body.style.overflow = previousBodyOverflow;
        body.style.paddingRight = previousBodyPaddingRight;
        body.style.position = previousBodyPosition;
        body.style.top = previousBodyTop;
        body.style.width = previousBodyWidth;

        window.scrollTo(0, lastScrollY);
    }
}

//export function CustomModal({isOpen, toggle, header, body, footer, modalOptions = {}}) {
export function CustomModal({isOpen, toggle, header, body, footer, size, zIndex}) {
    // To be able to customize the close button, by default it uses the same action as the Modal toggle, now it is in ModalHeader toggle={null}, if we want the close cross put toggle={toggle}

    //To add additional attributes to the custom Modal:
    //const { size, zIndex, ...otherAttributes } = modalOptions;

    const modalStyle = { zIndex: zIndex || 9999 };
    const modalBodyScrollStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        maxWidth: '100%'
    };
    const modalBodyContentStyle = {
        minWidth: '100%'
    };

    useEffect(() => {
        if (!isOpen) {
            return;
        }

        lockBodyScroll();

        return () => {
            unlockBodyScroll();
        };
    }, [isOpen]);


    return (
        <Modal size={size || 'lg'} isOpen={isOpen} toggle={toggle} className="border-0 custom-modal-outline" style={modalStyle}  keyboard={false} zIndex={zIndex || 9999}  backdrop="static">
            {header ?
                <ModalHeader  className="border-bottom-0 d-flex justify-content-center" toggle={null}>{header}</ModalHeader>
            : ""}
            <ModalBody className="py-4 text-center" style={modalBodyScrollStyle}>
                <div style={modalBodyContentStyle}>
                    {body}
                </div>
            </ModalBody>
            <ModalFooter className="justify-content-center border-top-0 pb-4">
                {footer}
            </ModalFooter>
        </Modal>
    );
}